import React from 'react'
import './blogNavigate.scss'

export default function BlogNavigate(props) {
  return (
    <div className="blog-navigate">
      <button className="skip-to-button" onClick={props.showSkipTo}>
        Skip to <i className="fa fa-list-ul"></i>
      </button>
    </div>
  )
}
